import { formatDateTime, formatTime, WindowType } from "../../../util";
import { Card } from "../../backend/backendapi";
import { KanbanState } from "../kanban.model";

declare var window: WindowType;

export function getStartTime(card: Card): string {
    const durations = card.durations?.filter(e => e.userId == getUserId()) ?? [];
    if (!durations.length) {
        return '';
    }

    const startTime = durations.map(e => e.timeStmp!).sort((l, r) => l.getTime() - r.getTime())[0];
    if (Date.now() - startTime.getTime() < 24 * 60 * 60 * 1000) {
        return formatTime(startTime);
    } else {
        return formatDateTime(startTime);
    }
}

export function getDurationSecondsSum(card: Card): number {
    const durations = card.durations?.filter(e => e.userId == getUserId()) ?? [];
    return durations.map(e => e.seconds!).reduce((l, r) => l + r, 0);
}

export function getUserId(): string {
    return window.application.kanban.user?.id ?? '';
}

export function getCardById(state: KanbanState, id: string): Card | null {
    for (let board of state.boards) {
        for (let ticket of (board.tickets ?? [])) {
            for (let card of (ticket.cards ?? [])) {
                if (card.id === id) {
                    return card;
                }
            }
        }
    }
    return null;
}